import { Grid, Typography } from "@mui/material";
import { MprcChipChoice, MprcRequestIndicator, MprcTextMuted } from "components";
import { MprcDatePicker } from "components/MprcDatePicker";
import { AvailableStickersQueryResponse, GetPublicationAdvancedOptionsDto, GetPublicationStickerDto } from "generated/CoreApi_v1";
import { Formaters } from "lib/Formaters";
import { useCoreApi } from "providers/CoreApiProvider";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export interface IStickerBoxValidation {
    viewStickerUntil?: boolean;
}

export interface IStickerDataProps {
    sticker: GetPublicationStickerDto | null;
    viewStickerUntil: Date | null;
}

interface IProps {
    advancedOptions: GetPublicationAdvancedOptionsDto;
    enabled: boolean;
    validation: IStickerBoxValidation;
    onUpdateState: (data: IStickerDataProps) => void;
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const DatePickerMaxDate = new Date('2100-01-01');
const DatePickerMinDate = new Date('1900-01-01');

export const PublicationStickerBox = (props: IProps) => {
    let {
        advancedOptions: { viewPeriodEnd, viewPeriodStart, sticker, viewStickerUntil },
        enabled,
        validation,
        onUpdateState
    } = props;


    const { t } = useTranslation("knowledge");
    const api = useCoreApi();

    const [stickers, setStickers] = useState<AvailableStickersQueryResponse[] | null>(null);

    ///
    const updateSticker = (data: GetPublicationStickerDto | null) => {
        onUpdateState({
            sticker: data?.stickerId == sticker?.stickerId ? null : data,
            viewStickerUntil: data?.requiredDeadline ? viewStickerUntil : null
        });
    };

    ///
    const updateViewStickerUntil = (date: Date | null) => {
        onUpdateState({
            sticker,
            viewStickerUntil: date
        });
    };

    ///
    useEffect(() => {
        async function load() {
            try {
                const result = await api.v1.knowledgePublication.availableStickers({});
                setStickers(result.data);
            }
            catch {
                setStickers(null);
            }
        }
        load();
    }, []);


    ///
    return (
        <>
            {
                enabled &&
                <Grid container justifyContent="flex-start" spacing={0.5} direction="column">
                    <Grid>
                        <MprcTextMuted>
                            <Typography variant="button">{t("Publication.AdvancedBox.StikerTitle")}</Typography>
                        </MprcTextMuted>
                    </Grid>
                    <Grid>
                        {
                            stickers == null
                                ? <MprcRequestIndicator />
                                : (
                                    <>
                                        {
                                            stickers?.map((s, index) => (
                                                <MprcChipChoice
                                                    key={s.stickerId}
                                                    label={s.name}
                                                    selected={s.stickerId == sticker?.stickerId}
                                                    onClick={() => updateSticker(s)}
                                                />
                                            ))
                                        }
                                    </>
                                )
                        }
                    </Grid>
                    {
                        sticker?.requiredDeadline &&
                        <Grid>
                            <Grid container>
                                <Grid>
                                    <MprcDatePicker
                                        label={Formaters.capitalize(t("Publication.StickerBox.DeadlineLabel"))}
                                        minDate={viewPeriodStart || DatePickerMinDate}
                                        maxDate={viewPeriodEnd || DatePickerMaxDate}
                                        timePartHour="endDate"
                                        value={viewStickerUntil}
                                        fullWidth
                                        required
                                        error={validation.viewStickerUntil === false}
                                        onChange={(date) => updateViewStickerUntil(date)}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    }
                </Grid>
            }
        </>
    );
};
